// Preserve the roles that already displayed the monthly report on their dashboard.
export default function canAccessRma(role) {
    return !!role && ['ROLE_MEDECIN', 'ROLE_INFIRMIER', 'ROLE_ADMINISTRATEUR', 'ROLE_SAGE_FEMME'].includes(role.nom)
}
